import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { ModelProvider } from '@/features/settings/model-context';
import { Toaster } from '@/components/feedback/toast-provider';
import { router } from '@/app/router';
import { queryClient } from '@/lib/query-client';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ModelProvider>
          <RouterProvider router={router} />
          <Toaster />
        </ModelProvider>
      </ThemeProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
